import React from "react"
import Layout from "../components/layout"
import Home from "../components/home/Home"

function IndexPage() {
  return (
    <Layout>
      <Home />
    </Layout>
  )
}

export default IndexPage
